<template>
  <div class="preview">
    <canvas id="canvas" width="300" height="300"></canvas>
    <div class="content" ref="editable" v-html="compiledMarkdown" @click="handleContentClick"></div>
  </div>
</template>
<script>

let marked = require("marked");
import pixelatePlugin from "../plugins/pixelate.js"

let plugins = [pixelatePlugin]

export default {
  name: "preview",
  props: ["input", "onSelect", "onChange"],
  data: function () {
    return {
      preEditString: "",
      editingTarget: null,
      pixelateValue: 1
    }
  },
  mounted: function () {

    /**
     * Scroll Event
     */
    document.querySelector(".preview").addEventListener("scroll", event => {
      window.requestAnimationFrame(this.updatePlugins)
    })

    document.addEventListener("scroll", event => {
      window.requestAnimationFrame(this.updatePlugins)
    })

    /**
     * Resize Event
     */

    window.addEventListener("resize", event => {
      window.requestAnimationFrame(this.updatePlugins)
    })
  },
  computed: {
    compiledMarkdown: function () {
      var that = this;

      if (this.input != "" && this.input != "null" && this.input != null) {
        localStorage.setItem("content", this.input)


        document.querySelectorAll(".content")[0].addEventListener("click", function (event) {
          if (document.querySelectorAll(".highlighted").length) {
            document.querySelectorAll(".highlighted")[0].classList.remove("highlighted")
          }
          event.target.classList.add("highlighted")
          that.onSelect(event.target.tagName)
        })

        setTimeout(() => {
          plugins.forEach(plugin => {
            plugin.mount();
          })
        })

        return marked(
          this.input,
          {
            breaks: true,
            sanitize: false
          }
        )
      }
    }
  },
  methods: {
    handleContentClick: function (event) {

      if (this.editingTarget) this.update()

      this.preEditString = event.target.innerHTML;
      this.editingTarget = event.target

    },
    update: function () {
      var oldContent = this.preEditString;
      var newContent = this.editingTarget.innerHTML;

      this.onChange(this.input.replace(oldContent, newContent))
    },
    updatePlugins: function () {
      plugins.forEach(plugin => {
        plugin.update();
      })
    }
  }
}

</script>
<style lang="scss">

.preview {
  width: 100%;
  overflow: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  max-height: 100vh;
  position: relative;

  * {
    box-sizing: border-box;
  }
}

.highlighted {
  outline: 1px solid #19B5FF;
}

[contenteditable] {
  outline: 0;
}

@media (max-width: 800px) {
  .preview {
    max-height: initial;
  }
}

</style>
